/**
 * Normalise un payload de type 'texte' (saisie libre) vers un format stable.
 *
 * Conserve `suffixe` (unité affichée après la ligne) et `correctAnswer` pour
 * la section corrections. `correctAnswer` peut être absent (réponse ouverte).
 */
export const normalizeSaisie = (payload, num) => {
    const contenu = payload?.contenu || {};
    const correctRaw = contenu.bonne_reponse;
    const correctAnswer = (correctRaw == null || correctRaw === '')
        ? null
        : String(correctRaw);
    return {
        num,
        question: payload?.texte || '',
        correctAnswer,
        suffixe: contenu.suffixe || '',
    };
};
